import Select from 'react-select';
import React, { useEffect, useState } from 'react'
import Modal from 'react-modal';
import { customStyles } from '../../../../helpers/modal_styles';
import './UsuarioCrearModal.css'
import { useDispatch } from "react-redux";
import Swal from 'sweetalert2';
import { onCrearUsuario } from '../../../../services/usuarios/usuarioService';



const roles = [
    { value: "1", label: "Administrador" },
    { value: "2", label: "Natural" },
    { value: "3", label: "Jurídico" },
    { value: "4", label: "Transportadora" },
];

const verificado = [
    { value: "NoValidado", label: "No validado" },
    { value: "Espera", label: "Espera" },
    { value: "Validado", label: "Validado" }
];

const estado = [
    { value: "0", label: "Desactivado" },
    { value: "1", label: "Activado" },
];

const ciudad = [
    { value: "Bogotá", label: "Bogotá" },
    { value: "Medellin", label: "Medellin" },
    { value: "Cali", label: "Cali" },
];



export const UsuarioCrearModal = ({  state, setState , setmodalCrear, modalCrear}) => {
    const dispatch = useDispatch();
    Modal.setAppElement('#root');

    const [formValues, setFormValues] = useState({});

    useEffect(() => {
        const initialState = {
            nombrerazonsocial: "",
            responsable: "",
            email: "",
            telefono: "",
            ciudad: "",
            estado: "",
            verificado: "",
            rol_id: "",
            password:"",
            password2:"",
        }
        setFormValues(initialState);


    }, [])


    //FUNCTION========================
    const closeModal = () => {
        setmodalCrear(false);
    }

    const crearUsuario = async(e) => {
        e.preventDefault();

        if (formValues.password !== formValues.password2) {
            return Swal.fire("Error", "Las contraseñas deben ser iguales", "error");
          }
          ;
        const resp = await dispatch(onCrearUsuario( 
            formValues.nombrerazonsocial,
            formValues.responsable,
            formValues.email,
            formValues.telefono,
            formValues.ciudad,
            formValues.estado,
            formValues.verificado,
            formValues.rol_id,
            formValues.password
            ));
            ;
            if (!!resp) {
            setState([...state, resp]);
            }


        //     const newArray = updateStateForId(usuario, resp);
        //     setUsuario([...newArray]);
            closeModal();

    }

    //FIN FUNCTION========================


    return (
        <Modal
            isOpen={modalCrear}
            // onAfterOpen={afterOpenModal}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="Example Modal"
        >

            <center><h3>Crear Usuario</h3></center>
            <br />
            <form onSubmit={crearUsuario}>
                <div className="form-row">
                    <div className="form-group col-md-6">
                        <input
                            placeholder="Nombre o razón social"
                            type="text"
                            name="nombrerazonsocial"
                            className="form-control"
                            value={formValues.nombrerazonsocial}
                            onChange={(e) =>
                                setFormValues({ ...formValues, nombrerazonsocial: e.target.value })
                            }
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <input
                            placeholder="responsable"
                            type="text"
                            name="responsable"
                            className="form-control"
                            value={formValues.responsable}
                            onChange={(e) =>
                                setFormValues({ ...formValues, responsable: e.target.value })
                            }
                        />
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group col-md-6">
                        <input
                            placeholder="email"
                            type="text"
                            name="email"
                            className="form-control"
                            value={formValues.email}
                            onChange={(e) =>
                                setFormValues({ ...formValues, email: e.target.value })
                            }
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <input
                            placeholder="telefono"
                            type="text"
                            name="telefono"
                            className="form-control"
                            value={formValues.telefono}
                            onChange={(e) =>
                                setFormValues({ ...formValues, telefono: e.target.value })
                            }
                        />
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-group col-md-6">
                        <input
                            placeholder="password"
                            type="password"
                            name="password"
                            className="form-control"
                            value={formValues.password}
                            onChange={(e) =>
                                setFormValues({ ...formValues, password: e.target.value })
                            }
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <input
                            placeholder="confirmar password"
                            type="password"
                            name="password2"
                            className="form-control"
                            value={formValues.password2}
                            onChange={(e) =>
                                setFormValues({ ...formValues, password2: e.target.value })
                            }
                        />
                    </div>
                </div>

                <div className="form-row">
                    <div className=" form-grupin col-md-6">
                        <Select options={roles} placeholder="Perfil"   onChange={(e) => setFormValues({ ...formValues, rol_id: Number(e.value) })} />
                    </div>
                    <div className=" form-grupin col-md-6">
                        <Select options={estado} placeholder="Estado"  onChange={(e) => setFormValues({ ...formValues, estado: Number(e.value) })} />
                    </div>
                </div>

                <div className="form-row">
                    <div className=" form-grupin col-md-6">
                        <Select options={verificado} placeholder="Verificado"  onChange={(e) => setFormValues({ ...formValues, verificado: e.value })} />
                    </div>
                    <div className=" form-grupin col-md-6">
                        <Select options={ciudad} placeholder="Ciudad"  onChange={(e) => setFormValues({ ...formValues, ciudad: e.value })} />
                    </div>
                </div>
                <button className="btn btn-primary">Crear</button>
            </form>

        </Modal>
    )
}
